import {
  Article,
  Author,
  BasicPage,
  ErrorPage,
  Gallery,
  Home,
  IndexTemplate,
  Loading,
  NotFound,
  Review,
  Search,
  Spec,
  SpecList,
} from 'Templates';

// if you are adding Templates also add in helpers/template.js
export const layouts = {
  ARTICLE: Article,
  AUTHOR_INDEX: Author,
  BASIC_PAGE: BasicPage,
  BESTS: Article,
  NEWS: Article,
  GALLERY: Gallery,
  HOMEPAGE: Home,
  INDEX_PAGE: IndexTemplate,
  INDEX_ARTICLE_PAGE: Article,
  PAGINATED_REVIEW: Review,
  PAGINATED_REVIEW_VERDICT: Review,
  REVIEW: Review,
  SEARCH_INDEX: Search,
  TAXONOMY_INDEX: IndexTemplate,
  VEHICLE_SPECS: Spec,
  VEHICLE_SPECLIST: SpecList,
  error: ErrorPage,
  loading: Loading,
  notFound: NotFound,
};
